export { Modal } from './modal';

export { closeModalInstance, openModalInstance, ModalHost } from './utils/host';
export type { ModalRenderer } from './utils/host';

export { registerModal, openModal } from './utils/registry';
export type { OpenModalAction } from './utils/registry';
export type { ModalRegistry } from './manifest';
